"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRedpackData = void 0;
const lodash_1 = require("lodash");
const vue_demi_1 = require("vue-demi");
const create_1 = require("../components/Modal/create");
const link_1 = require("../utils/link");
const url_1 = require("../utils/url");
const type_1 = require("./type");
const { request } = require('@futuweb/fego-render').common;
const commonApi = request.bindCommonApi('common-redpacket');
// 创建uuid
const cacheKey = 'common-redpacket-data:e668258b-7ac0-4a97-9763-564e82c561c4';
/**
 * 获取红包状态
 * @param actSign 活动标识
 * @returns 红包状态
 */
async function getRedpackStatus(actSign) {
    const res = await commonApi.get('get-redpacket-status', Object.assign({ actSign }, (0, url_1.getInviteAndGlobalContentFromUrl)()));
    return res;
}
/**
 * 发送红包
 * @param actSign 活动标识
 * @returns 发送红包结果
 */
async function sendRedpack(actSign) {
    const res = await commonApi.post('send-redpacket', Object.assign({ actSign }, (0, url_1.getInviteAndGlobalContentFromUrl)()));
    return res;
}
function showNoCrowdModal() {
    (0, create_1.quickCreateModal)(async () => Promise.resolve().then(() => __importStar(require('../components/NoCrowdModal/index.vue'))), {});
}
function useRedpackData(actSign) {
    const state = (0, vue_demi_1.reactive)({
        data: null,
        /**
         * 强制红包页面
         */
        forceRedpacketPage: false
    });
    function setForceRedpacketPage() {
        if (!state.data) {
            return;
        }
        if (!state.data.record) {
            return;
        }
        state.forceRedpacketPage = true;
    }
    async function refresh() {
        const res = await getRedpackStatus(actSign);
        state.data = res;
        // 0. 有重定向URL
        if (res.redirectUrl) {
            // 重定向到活动页面
            (0, link_1.toLink)(res.redirectUrl, {
                useCurrentWindow: true
            });
            return;
        }
        // 1. 活动已经结束
        if (!res.isActive) {
            // 活动已经结束
            (0, create_1.quickCreateModal)(async () => Promise.resolve().then(() => __importStar(require('../components/ActEndModal/index.vue'))), {});
            console.log('活动已经结束');
            return;
        }
        // 2. 判断是否非目标人群
        if (res.uid && !res.matchRule) {
            // 非目标人群
            showNoCrowdModal();
            console.log('非目标人群');
            return;
        }
    }
    const methods = {
        doSendRedpack: async () => {
            await sendRedpack(actSign);
        },
        setForceRedpacketPage,
        sendRedpack: (0, lodash_1.throttle)(async (isForce = false) => {
            try {
                if (isForce && state.forceRedpacketPage) {
                    state.forceRedpacketPage = false;
                    return {
                        showAnimate: false
                    };
                }
                if (!state.data) {
                    return {
                        showAnimate: false
                    };
                }
                if (!state.data.uid && state.data.isActive) {
                    (0, link_1.toLogin)();
                    return {
                        showAnimate: false
                    };
                }
                if (!state.data.isActive) {
                    return {
                        showAnimate: false
                    };
                }
                if (state.data.redirectUrl) {
                    return {
                        showAnimate: false
                    };
                }
                const { matchRule } = state.data;
                if (!matchRule) {
                    return {
                        showAnimate: false
                    };
                }
                if (state.data.record && !state.forceRedpacketPage) {
                    return {
                        showAnimate: false
                    };
                }
                const sendControll = type_1.CommonRedpacketSendControllByMap[matchRule.type];
                await sendControll(methods, isForce);
                await refresh();
                return {
                    showAnimate: true
                };
            }
            catch (error) {
                const code = Number(error === null || error === void 0 ? void 0 : error.code); //eslint-disable-line @typescript-eslint/no-magic-numbers
                if (code === 131005) {
                    // XXX: 未命中发奖规则
                    showNoCrowdModal();
                    if (state.data) {
                        state.data.matchRule = null; //eslint-disable-line @typescript-eslint/no-explicit-any
                    }
                }
                console.error(error);
            }
            // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        }, 1000),
        $callOtherComponentSendPrize: (0, vue_demi_1.ref)(null)
    };
    (0, vue_demi_1.onMounted)(() => {
        refresh();
    });
    return {
        state,
        methods
    };
}
const useRedpackDataWithCahce = function (actSign) {
    const key = `${cacheKey}:${actSign}`;
    if (window[key]) {
        return window[key];
    }
    const { state, methods } = useRedpackData(actSign);
    window[key] = {
        state,
        methods
    };
    return {
        state,
        methods
    };
};
exports.useRedpackData = useRedpackDataWithCahce;
//# sourceMappingURL=data:application/json;base64,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